// extracted by mini-css-extract-plugin
module.exports = {"button":"home_button__5p6hV","headings":"home_headings__Tn2XR"};